import * as common from './common.json';

export const en = {
  common,
};
